//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default RTableHeaders

  /**
   * Default headers
   */
  .from([
    {
      text: '#',
      value: 'wh_product_id',
    },
    {
      text: 'nombre',
      value: 'wh_product_name',
    },
    {
      text: 'cantidad',
      value: 'quantity',
      align: 'right',
      format: 'number-point',
    },
    {
      text: 'neto',
      value: 'net_price',
      align: 'right',
      format: 'currency',
    },
    {
      text: 'subtotal',
      value: 'subtotal',
      align: 'right',
      format: 'currency',
    },
  ])
